import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "@/App";
import "@/index.css";

// Debug hook for the headless test harness. Only invoked explicitly from
// /pagevoice/__diag.html — never runs automatically and never visible to
// users. Costs us nothing in the prod bundle besides the function literal.
import { convertPdfToEpub as _cvt } from "@/services/pdfImportService";
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).__pvDebugConvertPdf = async (url: string) => {
  const r = await fetch(url);
  if (!r.ok) throw new Error(`fetch ${r.status}`);
  const blob = await r.blob();
  const file = new File([blob], url.split("/").pop() || "test.pdf", { type: "application/pdf" });
  return await _cvt(file, {
    onProgress: (p) => console.log("[pv-debug]", p),
  });
};

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
